module.exports = __webpack_public_path__ + "static/img/币币交易_图1.0029680f.png";